import React from 'react'
import { CFooter, CImage, CLink } from '@coreui/react'

const AppFooter = () => {
  return (
    <CFooter>
      <div className='mb-2 sns-wrap'>
        <CLink href='http://pf.kakao.com/_WxfxgUxj' target='_blank'><CImage src='/img/i_kakao.png' width={40} height={40} alt="달콤자재창고 카카오톡 채널" className='w-40px' loading="lazy" /></CLink>
        <CLink href='https://www.instagram.com/dalkom_warehouse/' target='_blank'><CImage src='/img/i_insta.png' width={40} height={40} alt="달콤자재창고 인스타그램" className='w-40px ms-2' loading="lazy" /></CLink>
      </div>
      <div className='mb-2 fw-100'>
        <div><span className='fw-500'>주식회사 달콤자재창고</span> (대표이사: 장태욱)</div>
        {'서울시 강남구 도산대로28길 32, 3층 \n(주)달콤자재창고 사업자등록번호: 362-86-02633 \n통신판매업신고: 2022-서울강남-05243호 \n©2023 달콤자재창고 Inc. all rights reserved.'}
      </div>
      <div className='fw-500'>
        고객센터: <CLink className='white-text under-line' href='tel:070-8865-5568'>070-8865-5568</CLink> (평일 오전 9:00~ 오후 5:30 / 토·일·공휴일 휴무) / <br className='d-block d-md-none' /><CLink href='mailto:info@dal-kom.com' className='white-text under-line'>info@dal-kom.com</CLink>
      </div>
    </CFooter>
  )
}

export default React.memo(AppFooter)
